import React, { useEffect } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import Cal, { getCalApi } from "@calcom/embed-react";
import { FaCalendar, FaClock, FaSnowflake } from "react-icons/fa";

const Booking = () => {
  useEffect(() => {
    (async function () {
      const cal = await getCalApi({ namespace: "15min" });
      cal("ui", { hideEventTypeDetails: false, layout: "month_view" });
    })();
  }, []);

  return (
    <section className="section-padding bg-light">
      <Container>
        <Row className="text-center mb-5">
          <Col lg={8} className="mx-auto">
            <h2 className="display-5 fw-bold mb-3 text-gradient">
              Schedule Your AC Service
            </h2>
            <p className="lead text-muted">
              Book your AC installation, repair, or maintenance appointment
              online. Choose a convenient time that works for you.
            </p>
          </Col>
        </Row>

        <Row className="g-5">
          {/* Booking Calendar */}
          <Col lg={8}>
            <Card className="border-0 shadow-sm">
              <Card.Body className="p-4">
                <div className="text-center mb-4">
                  <FaCalendar
                    className="text-primary mb-3"
                    style={{ fontSize: "3rem" }}
                  />
                  <h3 className="fw-bold">Book Your Appointment</h3>
                  <p className="text-muted">
                    Select your preferred date and time for AC service
                  </p>
                </div>

                <Cal
                  namespace="15min"
                  calLink="moiz-ac-repair/15min"
                  style={{ width: "100%", height: "600px", overflow: "scroll" }}
                  config={{ layout: "month_view" }}
                />
              </Card.Body>
            </Card>
          </Col>

          {/* Booking Info */}
          <Col lg={4}>
            <div className="space-y-4">
              <Card className="border-0 shadow-sm">
                <Card.Body className="p-4">
                  <div className="d-flex align-items-start">
                    <FaClock className="text-primary me-3 mt-1" />
                    <div>
                      <h6 className="fw-bold mb-2">Service Hours</h6>
                      <p className="text-muted mb-1">
                        Monday - Friday: 8:00 AM - 6:00 PM
                      </p>
                      <p className="text-muted mb-1">
                        Saturday: 9:00 AM - 4:00 PM
                      </p>
                      <p className="text-muted mb-0">Emergency Service: 24/7</p>
                    </div>
                  </div>
                </Card.Body>
              </Card>

              <Card className="border-0 shadow-sm">
                <Card.Body className="p-4">
                  <div className="d-flex align-items-start">
                    <FaSnowflake className="text-primary me-3 mt-1" />
                    <div>
                      <h6 className="fw-bold mb-2">Services Available</h6>
                      <ul className="list-unstyled text-muted">
                        <li className="mb-1">• AC Installation</li>
                        <li className="mb-1">• AC Repair</li>
                        <li className="mb-1">• AC Maintenance</li>
                        <li className="mb-1">• Gas Refilling</li>
                        <li className="mb-0">• Emergency Service</li>
                      </ul>
                    </div>
                  </div>
                </Card.Body>
              </Card>

              <Card className="border-0 bg-primary text-white">
                <Card.Body className="p-4">
                  <h6 className="fw-bold mb-2">Need Immediate Help?</h6>
                  <p className="mb-3">
                    For emergency AC repairs, call us directly or use WhatsApp
                    for instant support.
                  </p>
                  <div className="d-grid gap-2">
                    <a
                      href="tel:+923054743725"
                      className="btn btn-light btn-sm"
                    >
                      Call Emergency: +92 305 4743725
                    </a>
                    <a
                      href="https://wa.me/923054743725"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-success btn-sm"
                    >
                      WhatsApp Support
                    </a>
                  </div>
                </Card.Body>
              </Card>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Booking;
